theme.accordion = (function () {
  function accordionBody(e) {
    // Select the buttons
    const faqButtons = e.querySelectorAll(".faq__list--item__button");

    faqButtons.forEach(function (btn) {
      // Step 1: Remove any old listeners by cloning the button (Clean Slate)
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      // Step 2: Add our fresh listener to the new button
      newBtn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation(); // This is the killer for conflicting scripts

        const singleFaqItem = newBtn.closest(".faq__list--item");
        const singleFaqItemBody = singleFaqItem.querySelector(".faq__body");
        
        // Check current state
        const isOpen = singleFaqItem.classList.contains("active");

        // Close all others (Accordion behavior)
        const allItems = e.querySelectorAll(".faq__list--item");
        allItems.forEach(item => {
          if (item !== singleFaqItem) {
            item.classList.remove("active");
            const body = item.querySelector(".faq__body");
            if (typeof slideUp === "function") slideUp(body);
            else body.style.display = 'none'; // Fallback if slideUp missing
          }
        });

        // Toggle the current one
        if (isOpen) {
          singleFaqItem.classList.remove("active");
          if (typeof slideUp === "function") slideUp(singleFaqItemBody);
          else singleFaqItemBody.style.display = 'none';
        } else {
          singleFaqItem.classList.add("active");
          if (typeof slideDown === "function") slideDown(singleFaqItemBody);
          else singleFaqItemBody.style.display = 'block';
        }
      });
    });
  }
  return accordionBody;
})();